<template>
  <div class="Brochure">
    <!-- https://720yun.gugushuzi.com/project/langting/map.html -->

    <div class="swiper-container BrochureSwiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide myslide"
          v-for="(item, index) in imglist"
          :key="index"
        >
          <!-- <div class="map mapapi" v-if="index == 26">
            <img :src="mapimg" alt="" />
          </div> -->
          <!-- <iframe
            class="map"
            src="https://720yun.gugushuzi.com/project/langting/map.html"
            scrolling="no"
            frameborder="0"
            v-if="index == 26"
          ></iframe> -->
          <div class="bg">
            <img :src="imglist[index]" alt="" style="width:100%;" />
          </div>
        </div>
      </div>
      <div class="swiper-pagination" style="margin-bottom:12vw;"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper";
import wx from "weixin-js-sdk";

import axios from "axios";
import $ from "jquery";
let bgurl = "./static/images/Brochure/bg/";
let BrochureUrl = "./static/images/Brochure/";
export default {
  data() {
    return {
      mapimg: bgurl + "map.png",
      imglist: []
    };
  },
  created() {
    this.getfilelist("../../static/images/Brochure");
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
      setTimeout(() => {
        this.goWxchat();
      }, 1000);
      // console.log(this.imglist);
    });
  },
  methods: {
    initSwiper() {
      let _that = this;

      this.swiper = new Swiper(".BrochureSwiper", {
        // direction: "vertical",
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          slideChangeTransitionStart: function() {
            //    _that.navlenth(this.activeIndex)
          }
        }
      });
    },
    getfilelist(dir, flielist) {
      // console.log(dir);
      const path = require("path");
      //读取文件的路径 是否遍历文件的子目录 匹配文件正则表达式
      const files = require.context(
        "../../static/images/Brochure",
        false,
        /\.(png|jpg|gif|jpeg|webp|ico)$/
      );
      // console.log(files);
      //files(key).default拿到该模块的vue对象
      files.keys().forEach((key, index) => {
        const name = path.basename(key);
        // console.log(index);
        this.imglist.push("./static/images/Brochure/" + (index + 1) + ".jpg");
        // console.log(name);
      });
    },
    async goWxchat() {
      // let url = encodeURIComponent(location.href.split("#")[0]);
      let url = location.href.split("#")[0];
      // console.log(url);
      let data = {
        url
      };

      // const res = await reqConfigSignature(data);
      axios({
        method: "post",
        url: "https://720yun.gugushuzi.com/tour.php?act=jssdk",
        params: {
          currentUrl: url
        }
      }).then(res => {
        // console.log(res); /* 将拿到的值，赋值给data */
        // const res = res.data;
        if (res.status === 200) {
          //拿到后端给的这些数据
          let appId = res.data.appId;
          let timestamp = res.data.timestamp;
          let nonceStr = res.data.nonceStr;
          let signature = res.data.signature;
          let linkimg =
            "https://720yun.gugushuzi.com/project/langting/logo.jpg";
          let title = "春江蘭庭";
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId, // 必填，公众号的唯一标识，填自己的！（开发者账号）
            timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr, // 必填，生成签名的随机串
            signature, // 必填，签名，见附录1
            jsApiList: [
              "updateTimelineShareData",
              "updateAppMessageShareData",
              "openLocation",
              "getLocation"
            ]
          });
          wx.ready(function(res) {
            //分享到朋友圈
            wx.updateTimelineShareData({
              title: title, // 分享时的标题
              link: url, // 分享时的链接  如果项目域名与JS接口安全域名不一致 可以采用此方式
              imgUrl: linkimg, // 分享时的图标
              success: function() {
                console.log("分享成功");
              },
              cancel: function() {
                console.log("取消分享");
              }
            });
            document.querySelector(".mapapi").onclick = function() {
              wx.openLocation({
                latitude: 29.609599,
                longitude: 106.458362,
                name: "春江兰庭营销中心",
                address: "重庆市沙坝区附近",
                scale: 14,
                infoUrl: "http://www.ilanluo.com"
              });
            };
            //分享给朋友
            wx.updateAppMessageShareData({
              title: title,
              desc: "一处江湾  一席蘭庭  一种生活",
              link: url,
              imgUrl: linkimg,
              type: "",
              dataUrl: "",
              success: function() {
                console.log("分享成功");
              },
              cancel: function() {
                console.log("取消分享");
              }
            });
          });

          wx.error(function(res) {
            console.log("回调失败", res);
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-media-controls {
  display: none !important;
}
.Brochure {
  width: 100vw;
  height: 100vh;
  background: #fff;

  .myslide {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    .map {
      position: absolute;
      z-index: 9999;
      left: 7vw;
      width: 86vw;
      /* height: 240px; */
      /* transform: translateY(5%); */
    }
    .bg {
      width: 100vw;
      height: auto;
      padding-top: 50px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Brochure.vue